export default __webpack_public_path__ + "static/media/origami.10eb7b8d.svg";